import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

export const getNotifications = (params = '') => Http.get(`/public/user/notifications${serialize(params)}`)
export const markRead = (id) => Http.get(`public/user/notifications/${id}`)
export const markReadAll = () => Http.post(`/public/user/notifications/mark-all-as-read`)
